import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from "@sentry/react";
import * as msal from "@azure/msal-browser";
import {
    BrowserRouter as Router,
} from 'react-router-dom';
import './css/theme.css';
import './css/fonts.css';
import './css/index.css';
import './css/sentry.css';
import 'react-toggle/style.css';
import { App } from './App';
import reportWebVitals from './reportWebVitals';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './authConfig';
import { Alert } from './utils/alert';

const EXCEPTIONS_TO_EXCLUDE = [
    'Notification.requestPermission is not a function',
    'The play() request was interrupted because a pause was requested by the user.',
    'This browser doesn\'t support the API\'s required to use the Firebase SDK',
    'interaction_in_progress',
    'Load failed (schmobileservicesapi.azurewebsites.net)',
]

Sentry.init({
    dsn: 'https://7c7bea8fcf4346b40c72336d5658cd91@o4510737881759744.ingest.us.sentry.io/4510834431557632',
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    integrations: [
        Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: false,
            beforeErrorSampling: (event) => {
                // Exclude some common errors from replays (still does traces)
                const message =
                event.exception?.values?.[0]?.value ||
                event.message ||
                "";

                const shouldExclude = EXCEPTIONS_TO_EXCLUDE.some(ex =>
                message.toLowerCase().includes(ex.toLowerCase())
                );

                return !shouldExclude;
            },
        }),
        Sentry.feedbackIntegration({
            colorScheme: 'light',
            showBranding: false,
        }),
        Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
        Sentry.browserTracingIntegration()
    ],

    sampleRate: 0.5,

    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.25,

    enableLogs: true,

    tracesSampleRate: 0.75,
    tracePropagationTargets: [
        "localhost",
        /^https:\/\/schmobileserviceswebapp-staging.azurewebsites.net/,
        /^https:\/\/responder.slandchc.com/,
        /^https:\/\/requestor.slandchc.com/,
        /^https:\/\/schmobileservicesapi.azurewebsites.net\/api/,
        /^https:\/\/schmobileservicesapi.azurewebsites.net\/ws/,
        /^https:\/\/schmobileservicesapi-staging.azurewebsites.net\/api/,
        /^https:\/\/schmobileservicesapi-staging.azurewebsites.net\/ws/
    ],
});


if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register(window.location.origin + '/serviceWorker.js')
        .then(function (registration) {
            // Registration was successful
            console.log('ServiceWorker registration successful with scope: ', registration.scope);
        }).catch(function (err) {
            // registration failed :(
            console.log('ServiceWorker registration failed: ', err);
        });
}

Alert.init();

// Apple requires interaction before sound can be played. This captures the context
document.addEventListener('click', Alert.unlock, { once: true });
document.addEventListener('touchstart', Alert.unlock, { once: true });

const msalInstance = new msal.PublicClientApplication(msalConfig);

ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
).render(
    // This really messes up data fetching...
    // <React.StrictMode>
    <MsalProvider instance={msalInstance}>
        <Router>
            <App />
        </Router>
    </MsalProvider>
    // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
